import script from "./ThankYouModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThankYouModal.vue?vue&type=script&lang=ts&setup=true"

import "./ThankYouModal.vue?vue&type=style&index=0&id=0f168594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f168594"]])

export default __exports__